module.exports = __webpack_public_path__ + "static/media/keep_stroking.ff20be69.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/keep_stroking.mp3
// module id = 512
// module chunks = 0